import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h2 className='text-center text-success'>Please Checkout your booking. Pay with online & mobile banking</h2>
        </div>
    );
};

export default Checkout;